import { useNavigate } from 'react-router-dom';
import { ArrowRight, Plane } from 'lucide-react';

const SKY_BG = 'https://images.unsplash.com/photo-1554976585-bf94aadbc26c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxFbWlyYXRlcyUyMGFpcnBsYW5lJTIwc21hbGwlMjBkaXN0YW50JTIwZmx5aW5nJTIwYmx1ZSUyMHNreXxlbnwwfHx8fDE3NzkyNjM3Nzh8MA&ixlib=rb-4.1.0&q=85';

export default function AirlineHomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{ backgroundImage: `url(${SKY_BG})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}
    >
      <div className="bg-white/95 backdrop-blur-md border-4 border-white rounded-3xl shadow-2xl p-8 sm:p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-sky-500 flex items-center justify-center mx-auto mb-4 shadow-lg border-4 border-white">
          <Plane className="w-10 h-10 text-white" strokeWidth={2.5} />
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black text-gray-900 mb-2">
          Airline Quiz
        </h1>
        <p className="font-body text-base text-gray-600 mb-6 leading-relaxed">
          Guess the airline from the logo! Spot airlines from India and around the world!
        </p>

        <div className="flex justify-center gap-3 mb-6">
          <span className="bg-sky-50 text-sky-700 text-xs font-bold px-3 py-1.5 rounded-full">
            10 Questions
          </span>
          <span className="bg-sky-50 text-sky-700 text-xs font-bold px-3 py-1.5 rounded-full">
            Indian + World Airlines
          </span>
        </div>

        <button
          data-testid="start-airline-quiz"
          onClick={() => navigate('/airline-quiz/play')}
          className="bg-sky-500 text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-sky-700 active:border-b-0 active:translate-y-[6px] transition-all hover:bg-sky-400 flex items-center gap-3 mx-auto shadow-lg"
        >
          Take Off!
          <ArrowRight className="w-6 h-6" />
        </button>

        <button
          data-testid="airline-back-studio"
          onClick={() => navigate('/')}
          className="mt-5 text-gray-500 font-bold text-sm hover:text-gray-800 transition-colors underline"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
